let latestRunId: number = 0;
let isProcessing: boolean = false;
let instances = 0;
const isStale = (thisRunId: number) => thisRunId !== latestRunId;

export const runSingletonOrWait = async (
  cb: (isStale: () => boolean) => void | Promise<void>,
  config?: { handleAfterTimeoutMs?: number; recheckConcurrentInstancesMs?: number }
) => {
  const startTimestamp = Date.now();
  const thisRunId = ++latestRunId;
  instances++;

  while (
    isProcessing &&
    (!config?.handleAfterTimeoutMs || Date.now() - startTimestamp < config?.handleAfterTimeoutMs)
  ) {
    await new Promise((resolve) => setTimeout(resolve, config?.recheckConcurrentInstancesMs ?? 200));
    if (isStale(thisRunId)) {
      instances--;
      return;
    }
  }

  if (config?.handleAfterTimeoutMs && Date.now() - startTimestamp > config?.handleAfterTimeoutMs)
    console.warn("handleState timeout bypassing isProcessing = TRUE (has been waiting over timeout)", {
      startTimestamp,
      handleAfterTimeoutMs: config?.handleAfterTimeoutMs,
      instances,
    });

  isProcessing = true;

  try {
    await cb(() => isStale(thisRunId));
  } finally {
    isProcessing = false;
    instances--;
  }
};
